<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,11C6,11,7,11,7,11C7,11,7,12,7,12C7,12.55,7.45,13,8,13C8.55,13,9,12.55,9,12C9,12,9,11,9,11C9,11,10,11,10,11C10.55,11,11,10.55,11,10C11,9.45,10.55,9,10,9C10,9,9,9,9,9C9,9,9,8,9,8C9,7.45,8.55,7,8,7C7.45,7,7,7.45,7,8C7,8,7,9,7,9C7,9,6,9,6,9C5.45,9,5,9.45,5,10C5,10.55,5.45,11,6,11C6,11,6,11,6,11ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM14,14C14,14,2,14,2,14C2,14,2,6,2,6C2,6,14,6,14,6C14,6,14,14,14,14C14,14,14,14,14,14ZM14,5C14,5,2,5,2,5C2,5,2,2,2,2C2,2,14,2,14,2C14,2,14,5,14,5C14,5,14,5,14,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AddRowBottom',
} as DefineComponent
</script>
